<script setup>
import MaterialInfoFields from "./MaterialInfoFields.vue";
import MaterialAssignmentInfo from "./MaterialAssignmentInfo.vue";

import notification from "@/utils/plugins/NotificationService";
import { computed, onMounted, ref } from 'vue';
import { useAuthStore } from "@/app/stores/authStore";
import { useUiStore } from "@/app/stores/uiStore";



import MaterialService from '@/api/services/materialAssignment.service';

const confirmedDateMaterial = ref();

// eslint-disable-next-line no-undef
const emit = defineEmits(['closeDialog'])

// eslint-disable-next-line no-undef
const props = defineProps({
    material: Object,
})


// eslint-disable-next-line no-unused-vars
const user = computed(() => {
    return authStore.getUserLogged;
})

const params = ref({});

const authStore = useAuthStore();
const uiStore = useUiStore();

const selectedMaterial = computed(() => {
    if (props && props.material && props.material.material) {
        return props.material.material;
    } else {
        return null;
    }
})


onMounted(() => {
    confirmedDateMaterial.value = toISOStringWithOffset();
})

const closeDialogNew = (saved = null) => {
    if (saved) {
        emit('closeDialog', saved)
    } else {
        emit('closeDialog')
    }
}
const confirmMaterial = () => {
    if (!confirmedDateMaterial.value) {
        notification.addNotification({
            type: 'error',
            message: 'Inserte una fecha',
            duration: 6000
        })
        return;
    }

    if (!selectedMaterial.value) {
        notification.addNotification({
            type: 'error',
            message: 'No se ha encontrado material recibido',
            duration: 6000
        })
        return;
    }

    params.value = {
        'confirmedByEmployeeAt': confirmedDateMaterial.value
    };
    uiStore.startLoading();
    MaterialService.confirmMaterial(props.material.id, params.value)
        .then((res) => {
            if (res.status === 200 || res.status === 201) {
                notification.addNotification({
                    type: 'success',
                    message: 'Material confirmado correctamente',
                    duration: 6000
                })
                closeDialogNew(true);
            }
            uiStore.stopLoading();
        })
        .catch(() => {
            uiStore.stopLoading();
        })
}

const pad = (n) => { return String(Math.floor(Math.abs(n))).padStart(2, '0'); }

const toISOStringWithOffset = (date = new Date()) => {
    const tzOffsetMin = -date.getTimezoneOffset();
    const sign = tzOffsetMin >= 0 ? '+' : '-';
    const offset = `${sign}${pad(tzOffsetMin / 60)}:${pad(tzOffsetMin % 60)}`;

    return date.getFullYear() +
        '-' + pad(date.getMonth() + 1) +
        '-' + pad(date.getDate()) +
        'T' + pad(date.getHours()) +
        ':' + pad(date.getMinutes()) +
        ':' + pad(date.getSeconds()) +
        offset;
}


</script>

<template>
    <div>
        <div class="header">
            <img style="width: 30px; margin-bottom: 14px;" src="@/assets/icons/box-blue.svg">
            <span class="header-title pl-4">
                Confirmar material
            </span>
        </div>
        <MaterialAssignmentInfo :assignment="material" />
        <MaterialInfoFields :material="selectedMaterial" />
        <div class="row f-flex">
            <div class="col-12">
                <div class="form-item date-picker mt-4 w-100 label-common pl-5">
                    <label for="ffrom" class="w-100">Fecha de confirmación de entrega</label>
                    <el-date-picker popper-class="material-modal-picker" id="ffrom" class="w-100" v-model="confirmedDateMaterial" name="deliv-date'" type="datetime"
                        placeholder="Fecha de confirmación de entrega" format="DD/MM/YYYY HH:mm" value-format="YYYY-MM-DD HH:mm"
                        :picker-options="{ firstDayOfWeek: 1 }" />
                </div>
            </div>
        </div>
        <!--  Botones guardar y cancelar -->
        <div class="row footer">
            <div class="col-md-12 mt-4" style="margin-left: -10px;">
                <div class="d-flex justify-content-end gap-3">
                    <div class="col-md-3">
                        <button class="btn btn-block btn_yellow edit-button" @click="closeDialogNew()"
                            style="">Cancelar
                        </button>
                    </div>
                    <div class="col-md-3">
                        <button type="submit" class="btn btn-block btn_red edit-button" @click="confirmMaterial">
                            Guardar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.header-title {
    font-size: 30px;
    margin-left: 5px;
    font-weight: 800;
    letter-spacing: -0.05em;
    color: #474ce6;
}

.custom-textarea:deep(.el-textarea__inner) {
    font-size: 14px !important;
    border-radius: 20px;
}

@media (max-width: 767.98px) {
    .footer .col-md-12 {
        margin-left: 0 !important;
    }

    .footer .d-flex {
        flex-direction: column;
    }

    .footer .col-md-3,
    .footer .edit-button {
        width: 100%;
    }
}

@media (max-width: 500px) {
    .header-title {
        font-size: 25px;
    }
}
</style>